import tables from './tables';
import utils from '../utils';

const setVideo = async (videoObject, token) => {
  try {
    await utils.postToMikMakFirebaseService(
      `set/${tables.videos}/${videoObject.id}`,
      videoObject,
      token,
    );

    return videoObject;
  } catch (e) {
    throw `Error saving video to product assets: ${e}`;
  }
};

const getVideosByBrandId = async (brandId, token) => {
  try {
    const { data } = await utils.getFromMikMakFirebaseService(
      `get/${tables.videos}?orderBy=actingBrandId&equalTo=${brandId}`,
      token,
    );

    return data;
  } catch (e) {
    throw `Error getting saved videos for brand ${brandId}:${e}`;
  }
};

export default {
  setVideo,
  getVideosByBrandId,
};
